<template>
    <div id="updateLogsIndex" class="updateLogsIndex" >
            <div class="mainLogs" v-for="(item, index) in logItems.updateLog" :key="index" >
              <div class="content">
                    <div class="tab-menu">
                        {{ item.name }}
                    </div>
                    <div class="tab-time-menu">
                        {{ item.time }}
                    </div>
                    <div class="tab-content-menu" v-html="item.list" v-highlight>
                    </div>
                    <div class="tab-button">
                      <el-button
                          @click="toDetail(item.id)"
                          type="text"
                          size="large">查看详情
                      </el-button>
                    </div>
                    <!-- <el-divider></el-divider> -->
              </div>


                    <!-- <div class="img" style="background-image:url(https://static.bimface.com/attach/a69b0c701b224787bc7d69a565908357_微信图片_20200415180653.png);">
                    </div> -->
            </div>

    </div>
</template>

<script>
import { Data } from './dataLog';
export default {
    name: 'updateLogsIndex',
    data() {
        return {
            logItems: Data,
        };
    },
    methods: {
        toDetail(id) {
          this.$router.push({
              name: 'logDetail',
              params: {
                id: id }
           })
        },
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'

@media (max-width: 1080px)
  .updateLogsIndex
    width 98% !important

.updateLogsIndex
  width 60%
  margin 0 auto
  padding-bottom 40px

.mainLogs {
  border-bottom 1px solid #ccc
  display flex
  padding 30px 0

}

.tab-menu{
  width 100%
  color black
  font-size 1.8rem
  font-weight bold
}

.tab-time-menu{
  color black
  font-size 14px
  padding-top 2%
  width 100%
}

.tab-content-menu{
  margin-top 15px
  color black
  font-size 14px
  font-size 1.1rem
  width 100%
}

.tab-button
  margin 15px 0;

.img
  min-width  300px
  height  180px
  background-position  center
  background-size  cover

.content
  width 820px

</style>



// WEBPACK FOOTER //
// src/pages/devCenter/updateLogs/updateLogsIndex.vue